import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {
  Button,
  Divider,
  IconButton,
  InputLabel,
  Stack,
  useMediaQuery,
} from "@mui/material";
import { FormTextField } from "UI/FormTextField";
import { DialogWindow } from "../DialogWindow";
import { FormSelectField } from "UI/FormSelectField";
import { required } from "utils";
import { useTheme } from "@emotion/react";
import { InfoDriver } from "./InfoDriver";
import { Captcha } from "components/Captcha";

export const QuestionForm = ({
  handleResetAndBack,
  recipient,
  originator,
  providerOptions,
  locationOptions,
  control,
  isButtonEnabled = true,
  loading,
  onQuestionSubmit,
  handleClose = null,
  isLocationsPresent,
  isMoreThanOneProvider,
  watch,
  reset,
  setError,
  setFormError,
  clearErrors,
  reloadAuthData,
  handleLogout,
  loginState,
  setLoginState,
  setLoading,
  setValue,
  setProviders,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <DialogWindow
      handleClose={handleClose}
      withCloseButton={!!handleClose}
      title={
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          <IconButton aria-label="close" onClick={handleResetAndBack}>
            <ArrowBackIosNewIcon />
          </IconButton>
          Ask a Question
        </Stack>
      }
      content={
        <Stack
          direction={isMobile ? "column" : "row"}
          justifyContent={"center"}
          alignItems={"top"}
          gap={2}
          pt={2}
        >
          <InfoDriver
            originator={originator}
            recipient={recipient}
            control={control}
            watch={watch}
            loading={loading}
            setLoading={setLoading}
            setError={setError}
            setFormError={setFormError}
            clearErrors={clearErrors}
            reloadAuthData={reloadAuthData}
            handleLogout={handleLogout}
            loginState={loginState}
            setLoginState={setLoginState}
            setValue={setValue}
            setProviders={setProviders}
          />
          <Divider orientation={"vertical"} flexItem />
          <Stack gap={1}>
            {isMoreThanOneProvider && (
              <Stack mt={1} alignItems={"flex-start"} flex={1}>
                <InputLabel htmlFor="providerId">
                  Select Your Practice Provider
                </InputLabel>
                <FormSelectField
                  id="providerId"
                  name="providerId"
                  control={control}
                  options={providerOptions}
                  withNone={false}
                  rules={{ required }}
                  doNotSortOptions
                />
              </Stack>
            )}
            {isLocationsPresent && (
              <Stack alignItems={"flex-start"} flex={1}>
                <InputLabel htmlFor="locationId">
                  Select Recipient Location
                </InputLabel>
                <FormSelectField
                  id="locationId"
                  name="locationId"
                  control={control}
                  options={locationOptions}
                  withNone={false}
                  doNotSortOptions
                />
              </Stack>
            )}
            <Stack direction={"column"} alignItems={"flex-start"}>
              <FormTextField
                id="question"
                name="question"
                placeholder="Type your question here"
                control={control}
                InputProps={{
                  autoComplete: "off",
                }}
                multiline
                sx={{
                  "& textarea": {
                    minHeight: 180,
                  },
                }}
              />
            </Stack>
            {!originator && (
              <Captcha
                control={control}
                setValue={setValue}
                setError={setError}
              />
            )}
          </Stack>
        </Stack>
      }
      actions={
        <Stack
          flex={1}
          direction={"row"}
          gap={1}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Button
            variant="outlined"
            color="primary"
            disabled={!isButtonEnabled || loading}
            onClick={reset}
            sx={{ padding: "8px 24px" }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!isButtonEnabled || loading}
            onClick={onQuestionSubmit}
          >
            Send
          </Button>
        </Stack>
      }
    />
  );
};
